import React, { useEffect, useState } from "react";
import "./message.scss";

import SendIcon from "../../assets/icons/chatSendIcon.svg";
import UserList from "./Websocket/Userlist";
import UseChat from "./Websocket/UseChat";
import ScrollToBottom from "react-scroll-to-bottom";

import Logo from "../../assets/images/final-logo.png";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { UsersList } from "./UsersList";
import { useDebounce } from "../../hooks";
import { usePermissions } from "../../hooks/usePermissions";
import UserAutocomplete from "./UserAutocomplete";
import { Box, IconButton, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";

const Message = () => {
  // Permission-based access control
  const { canCreate } = usePermissions("/message-center");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const {
    userDataList,
    setUserDataList,
    loaderForUserList,
    handleSearchUserlist,
    userReadMessages,
    startNewConversation,
    newConversationLoading,
  } = UserList();

  const [group, setGroup] = useState<any>();
  const [message, setMessage] = useState("");

  const [search, setSearch] = useState("");

  const [userChatId, setUserChatId] = useState("");

  const { messages, loader, sendMessage, isJoined, error, clearError } =
    UseChat(group?._id);

  const [chatIsOpen, setChatOpen] = useState(false);

  const handleGroudData = (data: any) => {
    if (data?.unreadCount !== 0) {
      userReadMessages(data?._id);
    }
    setGroup(data.sender);
  };

  const handleSendMessage = (e: any) => {
    userReadMessages(userChatId);
    e.preventDefault();

    if (message?.length > 0) {
      sendMessage(message);
      setMessage("");
    }
  };

  const messageOnEnter = (e: any) => {
    if (message?.length > 0) {
      sendMessage(message);
      setMessage("");
    }
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(() => {
    handleSearchUserlist(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const handleStartNewConversation = async (userId: string, user: any) => {
    try {
      const response = await startNewConversation(userId);
      if (response.success && response.data) {
        // Update the user data list with the new room
        setUserDataList((prevList: any[]) => {
          const exists = prevList.some((item) => item._id === response.data._id);
          if (exists) {
            return [
              response.data,
              ...prevList.filter((item) => item._id !== response.data._id),
            ];
          }
          return [response.data, ...prevList];
        });

        // Open the chat with the new user
        setChatOpen(true);
        setGroup(response.data.sender);
        setUserChatId(response.data._id);
      }
    } catch (error: any) {
      console.error("Failed to start new conversation:", error.message);
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Box>
        <Typography variant="h5" sx={{ mb: 2 }}>Nachrichtenzentrum</Typography>

        <div className="message-container">
          <div className="messaging">
            <div className={`inbox_msg${chatIsOpen ? " chat-open" : ""}`}>
              <div className="inbox_people">
                {/* New Conversation Section - only visible if user has create permission */}
                {canCreate && (
                  <div
                    style={{
                      padding: "8px 12px",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: "#00AEEF",
                        marginBottom: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      <span style={{ fontSize: "14px" }}>+</span>
                      Neue Unterhaltung
                    </div>
                    <UserAutocomplete
                      onSelectUser={handleStartNewConversation}
                      disabled={newConversationLoading}
                    />
                  </div>
                )}
                <div className="headind_srch">
                  <div className="filterHeaderAlignment">
                    <div className="searchAlignment">
                      <input
                        type="text"
                        placeholder="Unterhaltungen suchen..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      {search && (
                        <CloseIcon
                          style={{ fontSize: "14px", cursor: "pointer", color: "#bababa" }}
                          onClick={() => {
                            setSearch("");
                          }}
                        />
                      )}
                    </div>
                    <div className="filterDetailsAlignment"></div>
                  </div>
                </div>
                <div className="inbox_chat">
                  {loaderForUserList ? (
                    <span className="loaderForChat"></span>
                  ) : (
                    <UsersList
                      userDataList={userDataList}
                      setChatOpen={setChatOpen}
                      handleGroudData={handleGroudData}
                      setUserChatId={setUserChatId}
                    />
                  )}
                </div>
              </div>
              <div className="mesgs">
                {messages && (
                  <div className="chatMainHeadingAlignment">
                    {isMobile && (
                      <IconButton
                        size="small"
                        onClick={() => setChatOpen(false)}
                        sx={{ mr: 0.5 }}
                      >
                        <ArrowBackIcon />
                      </IconButton>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                      className="chatMainNameAlignment"
                    >
                      {group?._id && (
                        <>
                          <div style={{ width: "50px", height: "50px", position: "relative", flexShrink: 0 }}>
                            <div
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                overflow: "hidden",
                                backgroundColor: "#00AEEF",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {group?.userProfile?.[0] && (
                                <img
                                  src={group?.userProfile?.[0]}
                                  alt=""
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  onError={(e) => {
                                    (e.target as HTMLImageElement).style.display = "none";
                                  }}
                                />
                              )}
                              <span
                                style={{
                                  color: "#ffffff",
                                  fontSize: "18px",
                                  fontWeight: 600,
                                }}
                              >
                                {(group?.firstName?.trim() || group?.lastName?.trim())?.[0]?.toUpperCase() || "?"}
                              </span>
                            </div>
                            <span
                              style={{
                                position: "absolute",
                                bottom: "-1px",
                                right: "-1px",
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                backgroundColor: group?.socketId ? "#00E676" : "#bdbdbd",
                                border: "2px solid #fff",
                              }}
                              title={group?.socketId ? "Online" : "Offline"}
                            />
                          </div>
                          <h4>{group?.firstName?.trim() || group?.lastName?.trim() || "Nutzer"}</h4>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {chatIsOpen ? (
                  <ScrollToBottom className="msg_history">
                    {loader ? (
                      <span className="loaderForChat"></span>
                    ) : (
                      messages?.map((item: any, index: number) =>
                        item.senderType !== "chatbot" ? (
                          <div
                            key={`${item._id}-${index}`}
                            className="incoming_msg"
                          >
                            <div className="incoming_msg_img"></div>
                            <div className="received_msg">
                              <div className="received_withd_msg">
                                <p>{item?.data}</p>
                                <span className="time_date">
                                  {`${moment(item?.createdAt).format(
                                    "DD.MM.YYYY"
                                  )} ${moment(item?.createdAt).format("LT")}`}
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            key={`${item._id}-${index}`}
                            className="outgoing_msg"
                          >
                            <div className="sent_msg">
                              <p>{item?.data}</p>
                              <span className="time_date">
                                {`${moment(item?.createdAt).format(
                                  "DD.MM.YYYY"
                                )} ${moment(item?.createdAt).format("LT")}`}
                              </span>
                            </div>
                          </div>
                        )
                      )
                    )}
                  </ScrollToBottom>
                ) : (
                  <div className="new-logo-stlye-content-alignment">
                    <img alt="logo" src={Logo} />
                  </div>
                )}
                {chatIsOpen && (
                  <div className="type_msg">
                    {error && (
                      <div
                        className="chatErrorMessage"
                        style={{
                          backgroundColor: "#ffebee",
                          color: "#c62828",
                          padding: "8px 12px",
                          marginBottom: "8px",
                          borderRadius: "4px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontSize: "14px",
                        }}
                      >
                        <span>{error}</span>
                        <CloseIcon
                          style={{ cursor: "pointer", fontSize: "18px" }}
                          onClick={clearError}
                        />
                      </div>
                    )}
                    {canCreate ? (
                      <div className="chatBoxAlignment">
                        <div className="chatDetailsAlignment">
                          <div className="sendMessageInput">
                            {message?.substring(0, 21) === "https://" ? (
                              <img
                                src={message}
                                alt="img"
                                style={{
                                  height: "50px",
                                  width: "auto",
                                }}
                              />
                            ) : (
                              <input
                                type="text"
                                placeholder={
                                  isJoined
                                    ? "Nachricht eingeben..."
                                    : "Verbindung wird hergestellt..."
                                }
                                onChange={(e) => setMessage(e.target.value)}
                                name="data"
                                id="data"
                                value={message}
                                disabled={!isJoined}
                                onKeyDown={(e) =>
                                  e.key == "Enter" && isJoined && messageOnEnter(e)
                                }
                                style={{
                                  opacity: isJoined ? 1 : 0.6,
                                  cursor: isJoined ? "text" : "not-allowed",
                                }}
                              />
                            )}
                          </div>
                          {!!message?.length && isJoined && (
                            <div
                              className="sendButtonAlignment"
                              onClick={(e) => handleSendMessage(e)}
                            >
                              <img src={SendIcon} alt="SendIcon" />
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="chatBoxAlignment">
                        <div className="chatDetailsAlignment">
                          <div className="sendMessageInput">
                            <div style={{ padding: "10px", color: "#888", textAlign: "center" }}>
                              Sie haben keine Berechtigung, Nachrichten zu senden
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Paper>
  );
};

export default Message;
